module.exports = __webpack_public_path__ + "img/symbol_0.56d5d354.png";